module.exports = __webpack_public_path__ + "img/expert-photo.f3d26c73.png";